// components/QuantityCounter.jsx
import { CounterWrapper, CounterArrow, CounterValue } from "../styles/product";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const QuantityCounter = ({ value, max, onChange }) => {
    
  const handleIncrease = () => {
    // if (value >= max) return;
    onChange(value + 1);
  };

  const handleDecrease = () => {
    // if (value <= 0) return;
    onChange(value - 1);
  };

  const handleInputChange = (event) => {
    const raw = event.target.value;

    if (raw === "") {
      onChange(0);
      return;
    }

    let num = Number(raw);
    // if (Number.isNaN(num)) return;
    // if (num < 0) num = 0;
    // if (num > max) num = max;

    onChange(num);
  };

  return (
    <CounterWrapper>
      <CounterArrow
        type="button"
        onClick={handleIncrease}
        // disabled={value >= max}
      >
        <KeyboardArrowUpIcon fontSize="small" />
      </CounterArrow>

      <CounterValue
        type="number"
        value={value}
        onChange={handleInputChange}
        min={0}
        // max={max}
      />

      <CounterArrow
        type="button"
        onClick={handleDecrease}
        // disabled={value <= 0}
      >
        <KeyboardArrowDownIcon fontSize="small" />
      </CounterArrow>
    </CounterWrapper>
  );
};

export default QuantityCounter;